import { createSelector } from 'reselect';

import { getCatalog } from './getCatalog';

export const getDrawerIsVisible = createSelector(
  getCatalog,
  catalog => catalog.componentDrawerVisible,
);
